module.exports = __webpack_public_path__ + "static/media/employee.4bb4c003.jpg";